import AppIcon from "static/images/FinLogo.png";
import "./PrimaryNav.scss";
import {
 SettingOutlined,
 ReconciliationOutlined,
 LockFilled,
 ScanOutlined,
 MailOutlined,
 PieChartOutlined,
 FilePdfOutlined,
} from "@ant-design/icons";
import MMTLogo from "static/images/logos/mmt_logo.svg";
import ClientIcon from "static/images/mmtLogo.png";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import HotelRoundedIcon from "@mui/icons-material/HotelRounded";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HotelIcon from "@mui/icons-material/Hotel";
//import EmailIcon from '@mui/icons-material/Email';
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";


// {
//   "title": "Flight",
//   "icon": "FlightTakeoffRoundedIcon",
//   "subMenus": [
//     {
//       "title": "Booking vs Invoice",
//       "route": "/flights/bookingvsinvoice"
//     },
//     {
//       "title": "2B vs IRN",
//       "route": "/flights/invoicevs2b"
//     }
//   ],
//   "route": "/flights"
// },
// {
//   "title": "Credentials",
//   "icon": "KeyRoundedIcon",
//   "subMenus": [
//     {
//       "title": "GST Credentials",
//       "icon": "PercentRoundedIcon",
//       "subMenus": [],
//       "route": "/credentials/gst"
//     },
//     {
//       "title": "Airline Credentials",
//       "icon": "FlightTakeoffRoundedIcon",
//       "subMenus": [],
//       "route": "/credentials/airline"
//     },
//     {
//       "title": "Email Credentials",
//       "icon": "MailOutlined",
//       "subMenus": [],
//       "route": "/credentials/mail"
//     }
//   ],
//   "route": "/credentials"
// },


import { Avatar, Divider, Drawer, Dropdown, MenuProps, message } from "antd";
import Typography from "../Typography";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import SubMenu from "./SubMenu";
import MenuList from "./MenuItems.json";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import KeyRoundedIcon from "@mui/icons-material/KeyRounded";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import FlightTakeoffRoundedIcon from "@mui/icons-material/FlightTakeoffRounded";
import PercentRoundedIcon from "@mui/icons-material/PercentRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import { useRecoilState } from "recoil";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { userInfo } from "app/config/States/users";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SignalCellularAltOutlinedIcon from "@mui/icons-material/SignalCellularAltOutlined";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import RocketLaneIcon from "static/icons/rocketlane.png";
import Lottie from "react-lottie";
import { colorPicker } from "app/utils/color.helper";
import { apiGet } from "app/services/apiServices";
import { API_ENDPOINT_ONBOARDING_GENERATE_MAGIC_LINK_ROCKETLANE } from "app/scenes/Onboarding/onboarding.constants";
import TourIcon from "@mui/icons-material/Tour";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import GroupIcon from "@mui/icons-material/Group";
import LuggageIcon from "@mui/icons-material/Luggage";
import { appMetaConfig } from "global.constants";
import { getSubdomain } from "app/utils/generic.helper";
import KeyIcon from "@mui/icons-material/Key";
import DatasetIcon from "@mui/icons-material/Dataset";
import GridViewIcon from "@mui/icons-material/GridView";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import OtherHousesOutlinedIcon from "@mui/icons-material/OtherHousesOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import PercentIcon from "@mui/icons-material/Percent";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";


import { AppstoreOutlined } from "@ant-design/icons";
const menuIconMap: any = {
 TimelineRoundedIcon: <TimelineRoundedIcon style={{ fontSize: 28 }} />,
 KeyRoundedIcon: <KeyRoundedIcon style={{ fontSize: 28 }} />,
 QueryStatsRoundedIcon: <QueryStatsRoundedIcon style={{ fontSize: 28 }} />,
 NotificationsRoundedIcon: (
   <NotificationsRoundedIcon style={{ fontSize: 28 }} />
 ),
 ReconciliationOutlined: <ReconciliationOutlined style={{ fontSize: 28 }} />,
 FlightTakeoffRoundedIcon: (
   <FlightTakeoffRoundedIcon style={{ fontSize: 24 }} />
 ),
 PercentRoundedIcon: <PercentRoundedIcon style={{ fontSize: 24 }} />,
 MailOutlined: <MailOutlined style={{ fontSize: 24 }} />,
 DescriptionOutlinedIcon: <DescriptionOutlinedIcon style={{ fontSize: 24 }} />,
 SignalCellularAltOutlinedIcon: (
   <SignalCellularAltOutlinedIcon style={{ fontSize: 24 }} />
 ),
 TourIcon: <TourIcon style={{ fontSize: 24 }} />,
 LuggageIcon: <LuggageIcon style={{ fontSize: 22 }} />,
 WorkspacesIcon: <WorkspacesIcon style={{ fontSize: 22 }} />,
 GroupIcon: <GroupIcon style={{ fontSize: 22 }} />,
 AddToPhotosIcon: <AddToPhotosIcon style={{ fontSize: 22 }} />,
 HotelRoundedIcon: <HotelRoundedIcon style={{ fontSize: 22 }} />,
 HomeOutlinedIcon: <HomeOutlinedIcon style={{ fontSize: 22 }} />,
 CloudUploadOutlinedIcon: <CloudUploadOutlinedIcon style={{ fontSize: 22 }} />,
 HotelIcon: <HotelIcon style={{ fontSize: 22 }} />,
 KeyIcon: <KeyIcon style={{ fontSize: 22 }} />,
 FilePdfOutlined: <FilePdfOutlined style={{ fontSize: 22 }} />,
 DatasetIcon: <DatasetIcon style={{ fontSize: 22 }} />,
 GridViewIcon: <GridViewIcon style={{ fontSize: 22 }} />,
 PendingActionsOutlinedIcon: (
   <PendingActionsOutlinedIcon style={{ fontSize: 22 }} />
 ),
 OtherHousesOutlinedIcon: <OtherHousesOutlinedIcon style={{ fontSize: 22 }} />,
 RocketLaunchOutlinedIcon: (
   <RocketLaunchOutlinedIcon style={{ fontSize: 22 }} />
 ),
 PercentIcon: <PercentIcon style={{ fontSize: 22 }} />,
 AssuredWorkloadIcon: <AssuredWorkloadIcon style={{ fontSize: 22 }} />,
};


const settingSubMenu = [
 {
   title: "Members",
   icon: "GroupIcon",
   subMenus: [],
   route: "/settings/members",
 },
 {
   title: "Workspaces",
   icon: "WorkspacesIcon",
   subMenus: [],
   route: "/settings/workspace",
 },
];


export default function PrimaryNav(props: any) {
 const [activeMenu, setActiveMenu] = useState("");
 const [openNestedMenu, setOpenNestedMenu] = useState(false);
 const [subMenuItem, setSubMenuItem] = useState(null);
 const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
 const location = useLocation();
 const domain = getSubdomain();
 // const domain = "mmt";


 const handleOpenNestedMenu = (menuItem: any) => {
   // Only allow opening nested menu for VCC Demo
   if (menuItem.route === "/vcc" || menuItem.title === "Vcc Demo") {
     setOpenNestedMenu(!openNestedMenu);
     props.openMenu && props.openMenu();
     setSubMenuItem(menuItem);
     setActiveMenu(menuItem.route);
   } else {
     message.info("Please contact support@finkraft.ai");
   }
 };
 const handleCloseNestedMenu = () => {
   setOpenNestedMenu(false);
   props.openMenu && props.openMenu();
 };
 const navigate = useNavigate();
 const handleOpenSubMenu = async (menu: any) => {
   setActiveMenu(menu.route);
   if (menu.length > 0) {
     setOpenNestedMenu(!openNestedMenu);
     props.openMenu && props.openMenu();
   } else {
     // Only allow navigation to VCC route, show message for others
     if (menu.route === "/vcc") {
       navigate(menu.route);
     } else {
       message.info("Please contact support@finkraft.ai");
     }
   }
 };


 const handleLogout = () => {
   localStorage.clear();
   navigate("/auth/signin");
 };


 const bottomMenuItems: MenuProps = {
   items: [
     {
       key: "1",
       label: (
         <>
           <div className="UserAvatarInfoPrimaryNav">
             <Avatar style={{ backgroundColor: colorPicker("primary.700") }}>
               {userDetails?.email?.[0]?.toUpperCase()}
             </Avatar>
             <div className="UserInfo">
               <Typography variant="body2" weight={600}>
                 {userDetails?.name}
               </Typography>
               <Typography variant="xs" weight={400} style={{ color: "gray" }}>
                 {userDetails?.email}
               </Typography>
             </div>
           </div>
           <Divider style={{ margin: 0, marginTop: 8 }} />
         </>
       ),
       disabled: true,
     },


     {
       key: "4",
       danger: true,
       label: <div onClick={handleLogout}>Logout</div>,
     },
   ],
 };


 const checkIFRoutehasActive = (route: string) => {
   if (location.pathname.includes(route)) {
     return true;
   } else {
     return false;
   }
 };


 const appFinkraftMenu: any = [
   {
     title: "Invoices",
     icon: "AddToPhotosIcon",
     subMenus: [],
     route: "/invoices",
   },
 ];


 const subdoman = getSubdomain();
 const staticCDNURL = `https://static-assets.finkraftai.com/logo/${subdoman}.png`;


 const getFilteredMenu = (menuList: any) => {
   return menuList.filter(
     (menu: any) => !menu.hiddenDomain || !menu.hiddenDomain.includes(domain)
   );
 };


 return (
   <div className="PrimaryNav">
     <div className="NavigationController">
       <div className="TopNavigation">
        <div className="AppLogo">
          <img
            alt="appIcon"
            style={{ width: domain === "samsung" ? 54 : 72 }}
            src="https://static-assets.finkraftai.com/logo/finkraft.png"
          />
        </div>
         <div className="MenuContainer">
           {userDetails.create_type === "OPEN_SIGNUP" ? (
             // Render the specific menu item for OPEN_SIGNUP
             <div
               className={
                 "MenuItem " +
                 (activeMenu === "/integrations" ||
                   checkIFRoutehasActive("/integrations")
                   ? " active"
                   : "")
               }
               onClick={() => {
                 message.info("Please contact support@finkraft.ai");
               }}
             >
               {menuIconMap["HotelRoundedIcon"]}
               <Typography
                 variant="xs"
                 style={{
                   color:
                     activeMenu === "/integrations" ||
                       checkIFRoutehasActive("/integrations")
                       ? colorPicker("primary.700")
                       : "",
                 }}
               >
                 {/* Integration */}
                 Credentials
               </Typography>
             </div>
           ) : (
             // Render the existing logic for other cases
             [
               ...getFilteredMenu(MenuList),
               ...((domain === "mmt" &&
                 userDetails.account_type === "PARTNER") ||
                 domain === "app" ||
                 domain === "newdemo" ||
                 domain === "myyatra"
                 ? [
                   {
                     title: "Hotel",
                     icon: "HotelIcon",
                     subMenus: [],
                     route: "/hotel",
                   },
                 ]
                 : []),
               ...(domain === "app" && userDetails.gstinStatus
                 ? appFinkraftMenu
                 : []),
               ...(domain === "bcd"
                 ? [
                   ...(userDetails?.currentWorkspace?.name === "NetApp"
                     ? [
                       {
                         title: "Hotel",
                         icon: "HotelIcon",
                         route: "/hoteldemo",
                         subMenus: [],
                       },
                     ]
                     : []),
                   {
                     title: "Hotel GST Followup",
                     icon: "FilePdfOutlined",
                     route: "/hotel_followup",
                     subMenus: [],
                   },
                 ]
                 : []),
                 ...(userDetails?.email?.includes("finkraft.ai") ||
                 userDetails?.email?.includes("kgrp.in")
                 ? [
                   {
                     title: "Vcc Demo",
                     icon: "DatasetIcon",
                     route: "/vcc",
                     subMenus: [],
                   },
                 ]
                 : []),
              //  ...(userDetails?.email?.includes("finkraft.ai") ||
              //    userDetails?.email?.includes("kgrp.in")
              //    ? [
              //      {
              //        title: "Matcher",
              //        icon: "DatasetIcon",
              //        route: "/matcher",
              //        subMenus: [],
              //      },
              //    ]
              //    : []),
               ...(userDetails?.email?.includes("finkraft.ai") ||
                 userDetails?.email?.includes("kgrp.in")
                 ? [
                   {
                     title: "VAT",
                     icon: "PercentIcon",
                     route: "/VAT/dashboard",
                     subMenus: [
                       {
                         title: "Dashboard",
                         icon: "GridViewIcon",
                         route: "/VAT/dashboard",
                       },
                       {
                         title: "Analysis",
                         icon: "SignalCellularAltOutlinedIcon",
                         subMenus: [
                           {
                             title: "VAT Potential",
                             route: "/VAT/analysis/potential",
                           },
                           {
                             title: "VAT potential - finkraft WLL",
                             route: "/VAT/analysis/invoiceCompliance",
                           },
                           {
                             title: "Recovery",
                             route: "/VAT/analysis/recovery",
                           },
                           {
                             title: "Submission",
                             route: "/VAT/analysis/submission",
                           },
                         ],
                       },
                       {
                         title: "Details",
                         icon: "DescriptionOutlinedIcon",
                         subMenus: [
                           {
                             title: "Entities",
                             route: "/VAT/detail/entities",
                           },
                           {
                             title: "Applications",
                             route: "/VAT/detail/applications",
                           },
                           {
                             title: "Transactions",
                             route: "/VAT/detail/transactions",
                           },
                           {
                             title: "Saved Reports",
                             route: "/VAT/detail/saveReport",
                           },
                           {
                             title: "Previous Exports",
                             route: "/VAT/detail/previousExport",
                           },
                         ],
                       },
                       {
                         title: "Document Tracker",
                         icon: "PendingActionsOutlinedIcon",
                         route: "/VAT/documentTracker",
                       },
                       // {
                       //   title: "Tax Office",
                       //   icon: "OtherHousesOutlinedIcon",
                       //   route: "/VAT/taxOffice",
                       // },


                       {
                         title: "Government Rules",
                         icon: "AssuredWorkloadIcon",
                         route: "/VAT/governmentRules",
                       },
                     ],
                   },
                 ]
                 : []),
             ].map((menuItem: any, key: any) => {
               return (
                 (!userDetails.gstinStatus &&
                   userDetails.create_type === "OPEN_SIGNUP" &&
                   menuItem.flagCheck) || (
                   <div
                     key={key}
                     className={
                       "MenuItem " +
                       (activeMenu === menuItem.route ||
                         checkIFRoutehasActive(menuItem.route)
                         ? " active"
                         : "")
                     }
                     // onClick={() =>
                     //   menuItem.subMenus.length > 0
                     //     ? handleOpenNestedMenu(menuItem)
                     //     : handleOpenSubMenu(menuItem)
                     // }
                     onClick={() => {
                       // Only allow navigation to VCC Demo, show message for others
                       if (menuItem.route === "/vcc" || menuItem.title === "Vcc Demo") {
                         if (menuItem.subMenus.length > 0) {
                           handleOpenNestedMenu(menuItem);
                         } else {
                           handleOpenSubMenu(menuItem);
                         }
                       } else {
                         message.info("Please contact support@finkraft.ai");
                       }
                     }}


                   >
                     {menuIconMap[menuItem.icon]}
                     <Typography
                       variant="xs"
                       style={{
                         textAlign: "center",
                         color:
                           activeMenu === menuItem.route ||
                             checkIFRoutehasActive(menuItem.route)
                             ? colorPicker("primary.700")
                             : "",
                       }}
                     >
                       {menuItem.title}
                     </Typography>
                   </div>
                 )
               );
             })
           )}
         </div>
       </div>


       <div className="BottomNavigation">
       


        
         {domain !== "newdemo" &&
           (userDetails?.email?.includes("finkraft.ai") ||
             userDetails?.email?.includes("kgrp.in")) ? (
           <div
             className={
               "MenuItem " +
               (activeMenu === "settings_schema" ||
                 checkIFRoutehasActive("/settings/home")
                 ? " active"
                 : "")
             }
             onClick={() => {
               message.info("Please contact support@finkraft.ai");
             }}
           >
             <SettingsOutlinedIcon
               style={{ color: colorPicker("neutral.700") }}
               onClick={() => { }}
             />
             <Typography
               variant="xs"
               style={{
                 color: (
                   activeMenu === "settings_schema" ||
                     checkIFRoutehasActive("/settings/home")
                     ? " active"
                     : ""
                 )
                   ? colorPicker("primary.700")
                   : colorPicker("neutral.700"),
               }}
             >
               Settings
             </Typography>
           </div>
         ) : null}


         <div className="MenuItem" style={{ zIndex: 99999, marginBottom: 0 }}>
           <Dropdown
             menu={bottomMenuItems}
             placement="topRight"
             arrow
             overlayStyle={{ zIndex: 99999 }}
           >
             <Avatar
               size={36}
               style={{ backgroundColor: colorPicker("primary.700") }}
             >
               {userDetails?.email?.[0]?.toUpperCase()}
             </Avatar>
           </Dropdown>
         </div>


         <div
           className="MenuItem"
           style={{ marginBottom: 0, marginTop: 28, cursor: "auto" }}
         >
           <Typography
             variant="xs"
             style={{
               color: colorPicker("neutral.600"),
               fontSize: 10,
               marginBottom: 8,
             }}
           >
             Powered By
           </Typography>
           <img
             src={AppIcon}
             alt="FinkLogo"
             style={{ width: 48, opacity: 0.8, marginBottom: 12 }}
           />
         </div>
       </div>
     </div>
     <Drawer
       placement={"left"}
       closable={false}
       onClose={handleCloseNestedMenu}
       open={openNestedMenu}
       width={200}
       mask={false}
       maskClosable
       style={{ marginLeft: 80, padding: 0 }}
       zIndex={1}
     >
       <SubMenu
         onClose={handleCloseNestedMenu}
         menuItems={subMenuItem}
         iconMap={menuIconMap}
       />
     </Drawer>
   </div>
 );
}



